module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-grey-1-ecdf45a7545d5d0563f488b520711380.png";